import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Divider } from '@/components';
import { PremiumIcon } from '@/components/Navbar/Icons';
import { TshirtTeam } from '@/components/TshirtTeam';
import useAuth from '@/hooks/useAuth';
import usePinsAccount from '@/hooks/usePinsAccount';
import useTshirtAndShield from '@/hooks/useTshirtAndShield';
import ROUTES from '@/router/routes';

const TeamSection = () => {
  const { pinsData } = usePinsAccount();
  const navigate = useNavigate();

  const { userInitialData } = useAuth();
  const { data: dataTshirtShield } = useTshirtAndShield();

  return (
    <div className="flex flex-col h-full">
      <div className="py-7" />
      <div className="bg-white h-full w-full flex flex-col  text-base font-bold rounded-lg lg:px-4">
        <div className="bg-white flex justify-around my-4">
          <figure className="min-w-[4.5rem] w-[4.5rem] h-[4.4rem] flex items-center">
            <TshirtTeam
              shield={dataTshirtShield?.shield}
              tshirt={dataTshirtShield?.tshirt}
              withShield={true}
            />
          </figure>
          <div className="mx-7">
            <p className="text-lg font-bold text-gdt-gray wrap-anywhere">
              {userInitialData?.nombre_equipo}
            </p>
            <span className="text-gdt-gray-3 block mt-2">
              DT {userInitialData?.nombre_dt}
            </span>
          </div>
          <Button
            className="font-bold underline-offset-[6px]"
            type="button"
            variant="text"
            onClick={() => navigate(ROUTES.editAccount.myTeam)}
          >
            Editar
          </Button>
        </div>
        <Divider type="horizontal" />
        <div className="bg-white h-28 w-full flex justify-between items-center text-base text-white font-bold rounded-xl px-8">
          <div className="flex flex-col items-start relative gap-2">
            <p className="text-gdt-gray-4">PINES DISPONIBLES</p>
            <span className={'font-bold text-gdt-gray-2 text-lg '}>
              {!pinsData.isPremium ? (
                pinsData.pinsAvailable || 0
              ) : (
                <div className="flex items-center gap-1">
                  <figure className="scale-125">
                    <PremiumIcon context="page" variant="premium" />
                  </figure>
                  <span className="text-xs lg:text-sm text-gdt-status-yellow">
                    ILIMITADOS
                  </span>
                </div>
              )}
            </span>
          </div>
          <Button
            className="py-2 flex items-center text-xs h-9"
            type="button"
            variant={'primary'}
            onClick={() => navigate(ROUTES.myAccount)}
          >
            <span>Obtener pines</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(TeamSection);
